/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CardMessagingActivityQueued_EmbedQuery = {
    readonly queuedCount: number | null;
    readonly " $refType": "CardMessagingActivityQueued_EmbedQuery";
};
export type CardMessagingActivityQueued_EmbedQuery$data = CardMessagingActivityQueued_EmbedQuery;
export type CardMessagingActivityQueued_EmbedQuery$key = {
    readonly " $data"?: CardMessagingActivityQueued_EmbedQuery$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CardMessagingActivityQueued_EmbedQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sendAtFrom"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sendAtTo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CardMessagingActivityQueued_EmbedQuery",
  "selections": [
    {
      "alias": "queuedCount",
      "args": [
        {
          "fields": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "gte",
                      "variableName": "sendAtFrom"
                    },
                    {
                      "kind": "Variable",
                      "name": "lte",
                      "variableName": "sendAtTo"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "sendAt"
                },
                {
                  "kind": "Literal",
                  "name": "status",
                  "value": {
                    "in": [
                      "sent",
                      "scheduled",
                      "pending"
                    ]
                  }
                }
              ],
              "kind": "ObjectValue",
              "name": "_operators"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "kind": "ScalarField",
      "name": "reminderCount",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = 'fc7f0cb3a49e61d05311d46517b2f492';
export default node;
